export default __webpack_public_path__ + "static/media/easyContact.ae6b9c86.png";